const doc = [({"en":({"js":({"admin":({"users":({"index":({"the_user_was_deleted":"The user was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;